<template>
  <div style="background: white;padding:20px;padding-right:10px;margin-bottom:20px;">
    <div style="display: flex;justify-content: space-between">
      <div>成功或失败原因分析</div>
      <el-button size="mini" type="primary" @click="addContent">添加</el-button>
    </div>
    <div v-if="clueInfoPlain" style="margin-top:20px;max-height: 80vh;overflow: scroll;" v-loading="loading">
      <div style="padding-right:10px;" v-for="(plain,idx) in clueInfoPlain">
        <div class="plain-body">
          <div class="plain-header">
            <el-avatar icon="el-icon-user-solid" size="small" style="font-size: 12px;margin-right:8px;" ></el-avatar>
            <div class="plain-user-name">{{plain.user_name}}</div>
          </div>
          <div class="plain-content">{{plain.content}}</div>
          <div class="plain-time">添加于 {{plain.add_time}}</div>
        </div>
        <div style="width: 100%;height:1px;background: lightgrey;opacity: .2;margin: 8px 0" v-if="idx!==clueInfoPlain.length-1"></div>
      </div>
    </div>

    <el-empty v-else description="暂无数据"></el-empty>

    <add-content v-model="showDialog" :content-item="contentItem"/>
  </div>
</template>

<script>

import {
  getclueInfo
} from '../../../api/api'
import addContent from "@/component/Business/dialog/addContent";
export default {
  name: "BusinessResultAnalyze",
  props:["clue_id"],
  components:{
    addContent
  },
  data(){
    return {
      loading:false,
      clueInfoPlain:null,
      showDialog:false,
      contentItem:{
        key:"summary",
        label:"成功或失败原因分析"
      }
    }
  },
  async mounted() {
    this.refresh(false)
  },

  watch:{
    clue_id(){
      this.refresh()
    },
    showDialog(newVal){
      if(!newVal){
        this.refresh()
        this.$emit('refreshData',true)
      }
    }
  },

  methods:{
    async getData(){
      let postData = {
        clue_id:this.clue_id
      }
      let res = await getclueInfo(postData)
      let newVal = res.respData
      this.clueInfoPlain = null
      this.$nextTick(()=>{
        this.clueInfoPlain = newVal.summary_res
        this.loading = false
      })
    },

    async refresh(loading=true){
      this.loading = loading
      await this.getData()
    },
    addContent(){
      this.contentItem['clue_id'] = this.clue_id
      this.showDialog = true
    },
  }
}
</script>
<style lang="scss">
.el-row {
  margin-bottom: 40px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  height:200px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.plain-body{
  padding:10px;
  .plain-header{
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-bottom: 10px;
    .plain-img{
      width:20px;
      height:20px;
      border-radius: 50%;
      background-color: gray;
      margin-right:6px;
    }
    .plain-user-name{
      color: gray;
    }
  }
  .plain-content{
    color: black;
    font-size: 14px;
    margin-bottom: 10px;
    white-space: normal;
    word-break: break-all;
    word-wrap: break-word;
  }
  .plain-time{
    font-size: 10px;
    color: lightgrey;
  }
}

</style>

